<template>
    <v-dialog :width="width">
        <template v-slot:activator="{on}">
            <v-btn text v-on="on">Kontakt i pomoc techniczna</v-btn>
        </template>
        <v-card :loading="load">
            <v-card-title>Kontakt i pomoc techniczna</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col md="4">
                        <h3 class="mb-3">Telefon:</h3>
                        <span style="font-size: 1.5rem; font-weight: 300">+48 511 163 504</span>
                    </v-col>
                    <v-col md="4">
                        <h3 class="mb-3">Email:</h3>
                        <span style="font-size: 1.5rem; font-weight: 300">info@gadgetcloud.pl</span>
                    </v-col>
                </v-row>
                <div class="mt-4">
                    <my-form ref="contact_form" v-if="!message.sended">
                        <v-text-field :rules="[rules.required]" v-model="message.name" label="Imię i nazwisko" outlined></v-text-field>
                        <v-textarea :rules="[rules.required]" label="Treść wiadomości" v-model="message.content" outlined></v-textarea>
                        <v-btn :loading="load" color="primary" @click="send()">Wyślij</v-btn>
                    </my-form>
                    <div v-else class="empty-state">
                        <h4 style="font-size: 2rem; font-weight: 200">Wiadomość została wysłana</h4>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    import {sendMessage} from "../api/app";

    export default {
        computed:{
            width(){
                if(this.$vuetify.breakpoint.lgAndUp) return '50%';
                if(this.$vuetify.breakpoint.smAndUp) return '70%';
                return '90%';
            }
        },
        data:() => {
            return{
                load: false,
                message: {},
                rules:{
                    required: v => !!v || 'Ten element jest wymagany'
                }
            }
        },
        methods:{
            send(){
                if(this.$refs.contact_form.my_validate()){
                    this.load = true;
                    sendMessage(this.message).then(response => {
                        this.$set(this.message, 'sended', true);
                        this.load = false;
                    }).catch(e => {
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Nie udało się wysłać wiadomości', type: 'error'});
                        this.load = false;
                    })
                }
            }
        }
    }
</script>
